export function isEmptyDisplayValue(value: unknown): boolean {
  if (value === null || value === undefined) return true;
  const t = String(value).trim();
  return t === "" || t === "—";
}

export function formatDetailDate(iso?: string | null): string | null {
  if (!iso || isEmptyDisplayValue(iso)) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function formatDetailDateTime(iso?: string | null): string | null {
  if (!iso || isEmptyDisplayValue(iso)) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString();
}

/** Strip portal system-info footer from description when present. */
export function cleanTicketDescription(raw?: string | null): string {
  return (raw ?? "")
    .replace(/\s*\n*---\s*\n?🖥 System Info[\s\S]*?---\s*$/m, "")
    .trim();
}
